module.exports = {
  email: 'barshikar.s@northeastern.edu',
  resumeLink: '/Portfolio/resume.pdf',

  socialMedia: [
    {
      name: 'Email',
      url: 'mailto: barshikar.s@northeastern.edu',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/sej07',
    },

    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sejal-barshikar',
    },
  ],

navLinks: [
  {
    name: 'About',
    url: '/#about',
  },
  {
    name: 'Education',
    url: '/#education',
  },
  {
    name: 'Experience',
    url: '/#jobs',
  },
    {
    name: 'Projects',
    url: '/#projects',
  },
  {
    name: 'Research',
    url: '/#research',
  },
  {
    name: 'Contact',
    url: '/#contact',
  },
],

  colors: {
    green: '##68ffdb',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
